import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../components/ui/Button';
import AnimatedSection from '../components/ui/AnimatedSection';
import { Home } from 'react-feather';
import Seo from '../components/shared/Seo';
import { useTranslation } from 'react-i18next';

const NotFoundPage: React.FC = () => {
    const { t } = useTranslation('common');
    // This is the standard 404 content for pages that are genuinely not found.
    // All redirect logic has been moved to the server-side _redirects file for a definitive fix.
    return (
        <>
            <Seo
                title={t('notFoundPage.seoTitle')}
                description={t('notFoundPage.seoDescription')}
                noIndex={true}
            />
            <div className="flex items-center justify-center min-h-[70vh] py-24 text-center">
                <AnimatedSection>
                    <div className="mx-auto max-w-md px-6">
                        <h1 className="text-8xl font-extrabold gold-gradient-text">404</h1>
                        <h2 className="mt-4 text-3xl font-bold font-serif text-white">{t('notFoundPage.title')}</h2>
                        <p className="mt-4 text-lg text-white/80">
                            {t('notFoundPage.subtitle')}
                        </p>
                        <div className="mt-10">
                            <Button to="/" variant="primary" icon={<Home size={18} />}>
                                {t('notFoundPage.button')}
                            </Button>
                        </div>
                    </div>
                </AnimatedSection>
            </div>
        </>
    );
};

export default NotFoundPage;